<template >
    <vue-countdown-timer
        @start_callback="startCallBack('event started')"
        @end_callback="endCallBack('Offer Expired')"
        :start-time="'2018-10-10 00:00:00'"
        :end-time="end_at?end_at:endAt"
        :interval="1000"
        :end-text="lang.expired"
        class="text-center"
        >

        <template slot="countdown" slot-scope="scope">
            <div class="text-center ">
                    `<div class="text-center btn btn-bordered btn-black mx-md-1 px-1 px-md-3">
                        <span class="h1">{{scope.props.days}}</span>
                        <br>{{ lang.days }}
                    </div>
                    <div class="text-center btn btn-bordered btn-black mx-md-1 px-1 px-md-3">
                        <span class="h1">{{scope.props.hours}}</span>
                        <br>{{  lang.hours }}
                    </div>
                    <div class="text-center btn btn-bordered btn-black mx-md-1 px-1 px-md-3">
                        <span class="h1">{{scope.props.minutes}}</span>
                        <br>{{ lang.minutes }}
                    </div>
                    <div class="text-center btn btn-bordered btn-black mx-md-1 px-1 px-md-3">
                        <span class="h1">{{scope.props.seconds}}</span>
                        <br>{{ lang.seconds }}
                    </div>`
            </div>
        </template>
        <template slot="end-text" slot-scope="scope">
            <div class="text-center btn btn-bordered btn-black">
                <span class="h2 text-uppercase">{{ scope.props.endText}}</span>
            </div>
        </template>
    </vue-countdown-timer>
</template>

<script >
export default {
    name: 'Countdown',
    props: {
        lang: {
            type: Object,
        },
    },
    data() {
      return {
          endAt: (new Date).getTime()-5000000,
      }
    },
    mounted() {
        var z = this.findGetParameter('z');
        if(!isNaN(z) && null != z){
            this.endAt = new Date("20" + z.substring(0, 2), z.substring(2, 4) -1, z.substring(4, 6), 24);
        }else{
            this.endAt = (new Date()).setHours(24,0,0,0);
        }
    },
    methods: {
        findGetParameter(parameterName) {
            var result = null,
            tmp = [];
            var items = location.search.substr(1).split("&");
            for (var index = 0; index < items.length; index++) {
             tmp = items[index].split("=");
             if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            }
            return result;
        },
        startCallBack: function(x) {
            return;
        },
        endCallBack: function(x) {
            return;
        },
    },
};
</script>
